import type { ShoppingListDataFragment } from '@shared/gql/sostoslista-document-nodes'

import { useApolloClient } from '@apollo/client'
import { ShoppingListDataFragmentDoc } from '@shared/gql/sostoslista-document-nodes'

export const useListDataFragment = () => {
  const client = useApolloClient()

  return (storeId: string, listId: string) =>
    client.cache.readFragment({
      fragment: ShoppingListDataFragmentDoc,
      variables: {
        storeId,
      },
      fragmentName: 'ShoppingListData',
      id: client.cache.identify({
        id: listId,
        __typename: 'ShoppingList',
      }),
    })
}

export const useWriteListDataFragment = () => {
  const client = useApolloClient()

  return (storeId: string, listId: string, data: ShoppingListDataFragment) =>
    client.writeFragment({
      fragment: ShoppingListDataFragmentDoc,
      variables: {
        storeId,
      },
      data,
      fragmentName: 'ShoppingListData',
      id: client.cache.identify({
        id: listId,
        __typename: 'ShoppingList',
      }),
    })
}
